import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setCurrency } from "../../../store/slices/currency-slice";
import { useEffect } from "react";
import { BUSSINESS_ENUM, IHOMEPAGEData } from "../../../shared/commonUtils";
import {
  getUserPrefersLang,
  saveUserPrefersLang,
  setBussinessCurrency,
} from "../../../shared/helpersMethod";
import { FooterPhone, IconPhoneVolume } from "../../../assets/svgs/svgs";
import ArrowDownSvg from "../../../assets/svgs/ArrowDownSvg";
import { useSearchParams, useNavigate } from "react-router-dom";
const LanguageCurrencyChanger = ({ currency }: any) => {
  const queryString = window.location.search;
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(queryString);
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const currentLang = getUserPrefersLang();
  const callUsHandler = (phoneNumber: string) => {
    document.location.href = `tel:${phoneNumber}`;
    // dispatch(setCloseAllModal());
  };
  const changeLanguageTrigger = (e: any) => {
    // console.log(e.target.value);
    const languageCode = e.target.value;
    const newParams = new URLSearchParams(searchParams);
    newParams.set("lang", languageCode);
    document.cookie = `lang=${languageCode}; path=/; max-age=31536`;
    setSearchParams(newParams);
    i18n.changeLanguage(languageCode);
    if (languageCode === "ar") {
      // GoogleTranslate();
    }
    saveUserPrefersLang(languageCode);

    document
      .getElementsByTagName("html")[0]
      .setAttribute("lang", languageCode === "ar" ? "ar" : "en");
    document
      .getElementsByTagName("body")[0]
      .setAttribute("dir", languageCode === "ar" ? "rtl" : "ltr");
    window.location.reload();
  };

  const { bussinessData } = useSelector((state: any) => state.bussinessData);
  const setCurrencyTrigger = (e: any) => {
    const currencyName = e.target.value;
    dispatch(setCurrency(currencyName));
    setBussinessCurrency(currencyName);
  };
  useEffect(() => {
    if (bussinessData && Object.keys(bussinessData).length !== 0) {
      setBussinessCurrency(bussinessData.businessMetas.BUSSINESS_CCY);
      dispatch(setCurrency(bussinessData.businessCurrency));

      if (currentLang === null) {
        var newLang = bussinessData.defaultLang;
        var paramLang = urlParams.get("lang");
        if (paramLang) {
          newLang = paramLang;
        }
        i18n.changeLanguage(newLang);
        saveUserPrefersLang(newLang);
        getUserPrefersLang();
        if (newLang === "ar") {
          document.getElementsByTagName("html")[0].setAttribute("lang", "ar");
          document.getElementsByTagName("body")[0].setAttribute("dir", "rtl");
        }
        return;
      }
      if (currentLang !== null) {
        i18n.changeLanguage(currentLang);
      }
    }
    // console.log(bussinessData);
  }, [bussinessData]);

  return (
    <div className="language-currency-wrap">
      <div className="same-language-currency language-style">
        <span>
          {currentLang === "en"
            ? "English"
            : currentLang === "ar"
              ? "عربي"
              : ""}{" "}
          {/* <i className="fa fa-angle-down" /> */}
          <ArrowDownSvg />
        </span>
        <div className="lang-car-dropdown">
          <ul>
            <li>
              <button value="en" onClick={(e) => changeLanguageTrigger(e)}>
                English
              </button>
            </li>
            <li className="font-arabic">
              <button value="ar" onClick={(e) => changeLanguageTrigger(e)}>
                عربي
              </button>
            </li>
          </ul>
        </div>
      </div>
      {/*  
      <div className="same-language-currency use-style">
        <span>
          {currency.currencyName} <i className="fa fa-angle-down" />
        </span>
        <div className="lang-car-dropdown">
          <ul>
            <li>
              <button
                value={bussinessData.businessCurrency}
                onClick={(e) => setCurrencyTrigger(e)}
              >
                {bussinessData.businessCurrency}
              </button>
            </li>
          </ul>
        </div>
      </div>
      */}

      {bussinessData.businessID === BUSSINESS_ENUM["nb-flowers"] && (
        <div className="same-language-currency language-style">
          <span>
            <i style={{ top: "-2px" }} className="mr-5 ml-5">
              <IconPhoneVolume width={15} height={15} />
            </i>
            {/* <i className="fa fa-phone " style={{ padding: "0 8px 0 8px" }}></i> */}
            {/* <i className="fa fa-angle-down" /> */}
            <ArrowDownSvg />
          </span>
          <div className="lang-car-dropdown">
            <ul>
              {bussinessData?.businessOutlets &&
                bussinessData?.businessOutlets.map((item, index) => {
                  return (
                    <li>
                      <button
                        value={item.phone_number}
                        onClick={(e) => callUsHandler(e)}
                      >
                        {item.phone_number}
                      </button>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      )}

      {bussinessData.businessID !== BUSSINESS_ENUM["nb-flowers"] && (
        <div className="same-language-currency">
          <p
            onClick={() => {
              callUsHandler(
                bussinessData?.site_settings?.siteCallUsPhoneNumber
              );
            }}
          >
            {/* <i className="fa fa-phone " style={{ padding: "0 8px 0 8px" }}></i> */}
            <FooterPhone
              className="arabic-invert"
              height={14}
              width={18}
              fill="black"
            />
            <span className="bold mr-5 ml-5">{t("call_us")} </span>
            <span dir="ltr" className="bold">
              {" "}
              {bussinessData?.site_settings?.siteCallUsPhoneNumber}
            </span>
          </p>
        </div>
      )}
    </div>
  );
};

LanguageCurrencyChanger.propTypes = {
  currency: PropTypes.shape({}),
};

export default LanguageCurrencyChanger;
